import React from 'react';
/** Is value an array. */
export function isArray(value) {
    return Array.isArray(value);
}
/** Is value a function. */
export function isFunction(value) {
    return typeof value === 'function';
}
/** Is value JSX / React Element */
export function isJsx(value) {
    return React.isValidElement(value);
}
/** Is value a number. */
export function isNumber(value) {
    return typeof value === 'number';
}
/** Is value a regular object (functions, arrays and React elements excluded). */
export function isObject(value) {
    return !!value && typeof value === 'object' && !isFunction(value) && !isArray(value) && !React.isValidElement(value);
}
/** Is value a valid ReactText - string or number. */
export function isReactText(value) {
    return isNumber(value) || isString(value);
}
/** Is value a string. */
export function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
}
